import React from "react";
import "../pages/LandingPage.css";

export default function Procedure() {
  return (
    <div className="rulesContainer">
      <p style={{ fontWeight: "bold" }}>‘माइक के लाल‘ मे भाग लेने के लिए :</p>
      <p>
        1) फॉर्म पर जाएं :{" "}
        <a href="https://mumbaitak.mobiletak.com/">
          https://sahityatak.mobiletak.com/
        </a>{" "}
      </p>
      <p>2) चुने हुए कंटेस्टेंट्स को साहित्य तक की टीम संपर्क करेगी । </p>
      3) इवेंट एड्रेस : मेजर ध्यानचंद नेशनल स्टेडियम, इंडिया गेट, नई दिल्ली- 110001
      {/* India Today Group Mediaplex (Auditorium) FC-8 ,Ecity
      Bioscope Rd,Film City, Sector-16A,Noida ,UP-201301{" "} */}
      <p className="event-date-title"> 4)  इवेंट डेट :</p>
      <ol type="a" className="event-date">

        <li>18 नवंबर – 2pm से 8pm</li>

        <li>19 & 20 नवंबर – 12 noon से 8pm</li>
        {/* 4) माइक के लाल 18 नवंबर २०२२ को 2pm से 8pm और 19 & 20 नवंबर २०२२ को 12 noon से 8pm लाइव जायेगा साहित्य तक के
        फेसबुक, इंस्टाग्राम, यूट्यूब और तक अप्प पर। */}
      </ol>
    </div>
  );
}
